<template>
  <div>
    <table
      ref="crossTab"
      summary="This table of cross tabulation results has many columns: statistics, followed by a column for each selected statistic for each row response"
    >
      <thead>
        <tr>
          <th><div class="sr-only" style="min-width: 110px">No value</div></th>
          <th><div class="sr-only">No value</div></th>
          <th
            v-for="(
              statisticDefinition, columnIndex
            ) in reportModel.usedStatistics"
            scope="col"
            align="center"
            v-bind:key="columnIndex"
            :colspan="getNumberOfColumns(statisticDefinition)"
            :style="'width:' + getColumnWidth(statisticDefinition) + 'px;'"
          >
            <div class="column-title" style="text-align: center">
              {{ statisticDefinition.label }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="row-title-td" :colspan="numberOfColumns">
            <div class="row-title">
              <b>{{ reportModel.parms.row.variable.variableTitle }}</b>
            </div>
          </td>
          <td><div class="accessibleHide">No value</div></td>
          <td><div class="accessibleHide">No value</div></td>
        </tr>
        <crosstab-row-only
          v-for="(rowLevel, rowIndex) in bodyLevels"
          :key="(rowIndex + 1) * 100"
          :selectionModel="selectionModel"
          :reportModel="reportModel"
          :rowLevel="rowLevel"
          :row="rows[rowIndex]"
        ></crosstab-row-only>
      </tbody>
    </table>
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from "@/scripts/common";
import crosstabRowOnly from "@/components/crossTabulation/report/crosstabRowOnly";
import current from "@/scripts/current";

export default {
  props: ["levels", "row", "reportModel", "rows"],
  data: function () {
    var vm = this;
    return {
      selectionModel: current.selectionModel,
      numberOfColumns: 2 + this.reportModel.columnsPerStatistic * 3,
      bodyLevels: vm.levels.filter((l) => l.rowLevel.id !== 0),
    };
  },
  components: {
    // <my-component> will only be available in parent's template
    "crosstab-row-only": crosstabRowOnly,
  },
  mounted: function () {
    store.dispatch("loadedControls/mounted", {
      name: "crosstabTable",
      vm,
    });
  },

  methods: {
    addXlsxRowOnly,
    getNumberOfColumns: function (statisticDefinition) {
      let vm = this;
      var numberOfColumns = 1;
      if (vm.reportModel.parms.showCi && statisticDefinition.ci !== null) {
        numberOfColumns += 1;
      }
      if (vm.reportModel.parms.showSe && statisticDefinition.se !== null) {
        numberOfColumns += 1;
      }
      return numberOfColumns;
    },
    getColumnWidth: function (statisticDefinition) {
      var width = 61;
      if (statisticDefinition.ci !== null) {
        width += 96;
      }
      if (statisticDefinition.se !== null) {
        width += 33;
      }
      return width;
    },
  },
};
function addXlsxRowOnly(p, sheet, def) {
  var labels = [];
  sheet.columnWidths.push({ wch: 48.333 });
  labels.push("Statistics");

  p.statistics.forEach((definition) => {
    if (definition.apiName === "sampleSize") {
      labels.push(definition.label);
      sheet.columnWidths.push({ wch: 18.333 });
    } else {
      labels.push(definition.label);
      sheet.columnWidths.push({ wch: 18.333 });

      if (definition.ci !== null) {
        labels.push("C.I. for " + definition.label);
        sheet.columnWidths.push({ wch: 18.333 });
      }

      if (definition.se !== null) {
        labels.push("S.E. of " + definition.label);
        sheet.columnWidths.push({ wch: 18.333 });
      }
    }
  });
  sheet.addRow(labels);

  def.levelsGroupedByRows.forEach((rowLevel, i) => {
    var nextRow = [rowLevel.rowLevel.title];
    var apiData = rowLevel.apiData;
    p.statistics.forEach((definition, statisticIndex) => {
      addStatisticCells(p, nextRow, definition, rowLevel.apiStatistics[0]);
    });
    sheet.addRow(nextRow);
  });
}
function addStatisticCells(p, nextRow, definition, apiData) {
  if (definition.apiName === "sampleSize") {
    nextRow.push(getStatisticElement(p, apiData, definition, null));
  } else {
    nextRow.push(getStatisticElement(p, apiData, definition, "value"));
    if (definition.ci !== null)
      nextRow.push(
        getStatisticElement(p, apiData, definition, "confidenceInterval")
      );
    if (definition.se !== null)
      nextRow.push(
        getStatisticElement(p, apiData, definition, "standardError")
      );
  }
}

function getStatisticElement(p, apiData, definition, subName) {
  var theData = apiData[definition.apiName];
  if (subName != null) theData = theData[subName];
  return common.getAsNumber(theData);
}
</script>

<style scoped>
table {
  /*position: relative;*/
  /*table-layout: fixed;
    width: 100%;*/
  margin-bottom: 20px;
}

table td {
  overflow: hidden;
}

table tbody tr:last-child td {
  border: none;
}

table td.statistic-total {
  text-align: center;
}
/*table td.nth-child(2) {
      white-space: nowrap;
    }*/
td {
  white-space: nowrap;
}

table td.statistic-cell {
  /*white-space: nowrap;*/
}

.statistic-label {
  padding: 0px 10px 0px 10px;
  /*white-space: nowrap;*/
}

table tr.first-row td:nth-child(2) {
  /*border-left: 2px solid;*/
}

table tr:not(.total-group) td.statistic-value {
  border-left: 2px solid;
}

td.statistic-value {
  padding-left: 10px;
}

table tr.first-row td.statistic-cell {
  border-top: 2px solid;
}

table {
  padding-top: 15px;
  /*margin-left: 50px;*/
}

table tr.first-row td {
  padding-top: 4px;
}

table tr.first-row td {
  padding-top: 15px;
}

table tr.last-row td {
  padding-bottom: 15px;
}

div.column-title {
  background-color: #8eab6b;
  width: fit-content;
  padding: 5px 10px 5px 10px;
  min-width: 200px;
}

.column-headings {
  background-color: #8eab6b;
  width: fit-content;
  padding: 5px 10px 5px 10px;
}

td.row-title-td {
  background-color: #c1d5b0;
}

div.row-title {
  width: fit-content;
  padding: 5px 10px 5px 10px;
  min-width: 200px;
}

.row-heading {
  width: fit-content;
  background-color: #c1d5b0;
  padding: 5px 10px 5px 10px;
}

.hidden-column {
  background-color: #c1d5b0;
}
</style>
